
const exeptions = {
  // 'new-lk2.sms-dnevnik.com': 'https://api2.sms-dnevnik.com',
  'menu0.sms-dnevnik.com': 'https://api0.sms-dnevnik.com',
  // 'school.admgornnov.ru': 'https://apiskud.admgornnov.ru',
  // 'new-cabinet.kengudetyam.ru': 'https://api5.kengudetyam.ru',
};

export const getDomain = (defDomain: string = 'sms-dnevnik.com') => {
  const parts = document.location.hostname.split('.');
  return (parts[0] === 'localhost' ? defDomain : parts.slice(1).join('.'));
};

const getAPIHost = (hostname: string): string => (
  exeptions[hostname] || `https://api.${getDomain()}`
);

// const host = 'http://api0.sms-dnevnik.com/rest/ping' // сервер недоступен
const host = process.env.NODE_ENV === 'production'
  ? getAPIHost(document.location.hostname)
  : process.env.REACT_APP_API_URL

export default host;
